import axios from 'axios';

const getToken = () => localStorage.getItem('token') || sessionStorage.getItem('token');

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { 'Content-Type': 'application/json' },
});

// 토큰 만료 7일 이내면 자동 갱신
const checkAndRefreshToken = async () => {
  const token = getToken();
  if (!token) return;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000;
    const now = Date.now();
    const sevenDays = 7 * 24 * 60 * 60 * 1000;
    if (exp - now < sevenDays && exp > now) {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/refresh`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const newToken = res.data.access_token;
      if (localStorage.getItem('token')) localStorage.setItem('token', newToken);
      else sessionStorage.setItem('token', newToken);
    }
  } catch {}
};

client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const currentPath = window.location.pathname;
      // 로그인/회원가입/랜딩/pricing 페이지가 아닐 때만 토큰 삭제
      // 단, 비로그인 허용 페이지에서는 리다이렉트 안 함
      const publicPaths = ['/', '/login', '/register', '/pricing'];
      const isPublic = publicPaths.some(p => currentPath === p);
      if (!isPublic) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/login?expired=1';
      }
    }
    return Promise.reject(err);
  }
);

checkAndRefreshToken();

export default client;
